// store/orders/mutations.js
import { pedidosItem } from "@/interfaces/Pedidos";
import { OrdersState } from ".";

const RESET_CART_ITEMS = "RESET_CART_ITEMS";

const mutations = {
  updateCartItems(state: OrdersState, cartItems: any) {
    state.total_general_mone = cartItems.total_general_mone;
    state.total_general_ext = cartItems.total_general_ext;
    state.total_general_mone_ext = cartItems.total_general_mone_ext;
    state.total_unidades = cartItems.total_unidades;
    state.total_renglones = cartItems.total_renglones;
    state.desc_indexados_marca = cartItems.desc_indexados_marca;
    state.marcas = cartItems.marcas;
    state.total_general = cartItems.total_general;
    state.cartItems = cartItems;
  },

  updateCartItemsQuantity(state: OrdersState, quantity: number) {
    state.cartItemsQuantity = quantity;
  },

  addToCart(state: OrdersState, product: any) {
    try {
      const existingCartItem = state.cartItems.items.find(
        (item: any) => item.codprod === product.codprod
      );

      if (!existingCartItem) {
        state.cartItemsQuantity += 1;
      }
    } catch (error) {
      state.cartItemsQuantity += 1;
    }
  },

  addAllToCart(state: OrdersState, items: any) {
    const existingItems = [];

    for (const newItem of items) {
      const existingItem = state.cartItems.items.find(
        (cartItem: any) => cartItem.codprod === newItem.codprod
      );

      if (!existingItem) {
        existingItems.push(newItem);
      } else {
        existingItem.quantity = newItem.quantity;
        existingItem.discountItem = newItem.discountItem;
        existingItem.discountMarca = newItem.discountMarca;

        existingItems.push(existingItem);
      }
    }

    state.cartItems.items = [...existingItems];
  },

  removeOneFromCart(state: OrdersState, barra: any) {
    const cartItemToRemove = state.cartItems.items.find(
      (item: any) => item.barra === barra
    );

    if (cartItemToRemove) {
      state.cartItemsQuantity -= 1;
    }

    state.cartItems.items = state.cartItems.items.filter(
      (product: any) => product.barra !== barra
    );
  },

  removeFromCart(state: OrdersState, marca: any) {
    const cartItemsToRemove = state.cartItems.items.filter(
      (item: any) => item.marca === marca
    );

    cartItemsToRemove.forEach(() => {
      state.cartItemsQuantity -= 1;
    });

    state.cartItems.items = state.cartItems.items.filter(
      (product: any) => product.marca !== marca
    );
  },

  setItemDiscountMarca(
    state: OrdersState,
    {
      cartItemsToApplyDiscount,
      marca,
      discount,
    }: { cartItemsToApplyDiscount: any; marca: string; discount: number }
  ) {
    const matchingItems = cartItemsToApplyDiscount.filter(
      (item: any) => item.marca === marca
    );

    state.cartItems.items = state.cartItems.items.map((item: any) => {
      if (matchingItems.includes(item)) {
        return {
          ...item,
          discountMarca: discount,
        };
      }
      return item;
    });
  },

  updateItemQuantity(
    state: OrdersState,
    { codprod, quantity }: { codprod: string; quantity: number }
  ) {
    const index = state.cartItems.items.findIndex(
      (item: any) => item.codprod === codprod
    );
    if (index !== -1) {
      state.cartItems.items[index].quantity = quantity;
    }
  },

  updateItemDiscount(
    state: OrdersState,
    { codprod, discount }: { codprod: string; discount: number }
  ) {
    const index = state.cartItems.items.findIndex(
      (item: any) => item.codprod === codprod
    );
    if (index !== -1) {
      state.cartItems.items[index].discountItem = discount;
    }
  },

  [RESET_CART_ITEMS](state: OrdersState) {
    state.cartItems = [];
  },

  updateIndexedDiscount(
    state: OrdersState,
    {
      codprod,
      discount,
      jsonDiscounts,
    }: { codprod: string; discount: number; jsonDiscounts: string }
  ) {
    const index = state.cartItems.items.findIndex(
      (item: any) => item.codprod === codprod
    );
    if (index !== -1) {
      state.cartItems.items[index].total_indexado = discount;
      state.cartItems.items[index].desc_indexados = jsonDiscounts;
    }
  },

  updateIndexedDiscountMarca(
    state: OrdersState,
    {
      marca,
      discount,
      jsonDiscounts,
    }: { marca: string; discount: any; jsonDiscounts: string }
  ) {
    const filteredItems = state.cartItems.items.filter(
      (item: any) => item.marca === marca
    );

    filteredItems.forEach((item: any) => {
      item.discountMarca = parseFloat(discount).toFixed(2);
      item.desc_indexados_marca = jsonDiscounts;
    });
  },

  // ✅ FIX: payload consistente { codprod, cost }
  updateItemCost(
    state: OrdersState,
    { codprod, cost }: { codprod: string; cost: number }
  ) {
    const found = state.cartItems.items.find(
      (i: pedidosItem) => i.codprod === codprod
    );

    console.log("Updating item cost:", codprod, cost);

    if (found) {
      // Por compatibilidad con otras partes del sistema
      found.neto = cost;
    }
  },
};

export default mutations;
